import { registerSystemInfoTab } from "routes/sfg20-admin/plugins/system-info/register-system-info-tab"
import { StatsOverview } from "routes/sfg20-admin/plugins/system-info/current-usage-tab/stats-overview"

registerSystemInfoTab("Current Usage", <StatsOverview $lazy />, 1)
